<div #actualTarget>
	<button class="btn btn-outline-secondary btn-xs" (click)="menu.toggle($event)">
		<i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
	</button>
	<p-menu #menu [model]="items" [popup]="true" appendTo="body" styleClass="task-pmenu"></p-menu>
</div>